import React, { useState } from 'react';
import { Box, Button, Popover, Stack, Typography } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { formatCurrency } from '../../../../utils';
import { useTranslation } from 'react-i18next';

export default function PriceBreakdownPopover({
  total,
  basePrice,
  pickups,
  coldDeliveries,
  oreti,
  isMobile = false,
}) {
  const { t } = useTranslation(['glossary']);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'price-breakdown-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-describedby={id}
        onClick={handleClick}
        variant="outlined"
        color="success"
        size={isMobile ? 'small' : 'medium'}
        endIcon={
          <KeyboardArrowDownRoundedIcon
            sx={{
              transition: 'transform 150ms ease',
              transform: open ? 'rotate(180deg)' : 'rotate(360deg)',
            }}
          />
        }
        sx={{
          borderRadius: 1,
          px: 1.5,
          py: 0.5,
          fontWeight: 700,
          fontSize: isMobile ? 13 : 14,
          textTransform: 'none',
        }}
      >
        {formatCurrency({ amount: total })}
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 2,
              px: 2,
              py: 1.5,
              minWidth: 220,
            },
          },
        }}
      >
        <Stack spacing={1} color={'text.secondary'}>
          {basePrice > 0 && (
            <Stack direction="row" spacing={1} alignItems="center">
              <AttachMoneyRoundedIcon fontSize="small" />
              <Typography variant="body2" color="text.secondary">
                {t('base_price', { ns: 'glossary' })}{' '}
              </Typography>
              <Box flexGrow={1} />
              <Typography>{formatCurrency({ amount: basePrice })}</Typography>
            </Stack>
          )}

          {coldDeliveries > 0 && (
            <Stack direction="row" spacing={1} alignItems="center">
              <AcUnitIcon fontSize="small" />
              <Typography variant="body2" color="text.secondary">
                {t('cold_deliveries', { ns: 'glossary' })}{' '}
              </Typography>
              <Box flexGrow={1} />
              <Typography>
                {formatCurrency({ amount: coldDeliveries })}
              </Typography>
            </Stack>
          )}

          {pickups > 0 && (
            <Stack direction="row" spacing={1} alignItems="center">
              <HomeRoundedIcon fontSize="small" />
              <Typography variant="body2" color="text.secondary">
                {t('withdraw', { ns: 'glossary' })}{' '}
              </Typography>
              <Box flexGrow={1} />
              <Typography>{formatCurrency({ amount: pickups })}</Typography>
            </Stack>
          )}

          {oreti > 0 && (
            <Stack direction="row" spacing={1} alignItems="center">
              <HomeRoundedIcon fontSize="small" />
              <Typography variant="body2" color="text.secondary">
                {t('entel_withdraw', { ns: 'glossary' })}{' '}
              </Typography>
              <Box flexGrow={1} />
              <Typography>{formatCurrency({ amount: oreti })}</Typography>
            </Stack>
          )}
        </Stack>
      </Popover>
    </>
  );
}
